module.exports = __webpack_public_path__ + "img/467.be7829f1.jpg";